module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-886.bfc4efb2.jpg";